import OrganizationsTable from './OrganizationsTable'
export default OrganizationsTable


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/OrganizationTab/OrganizationTable/index.js